import RestResource from '../rest.service';

export default class ConfigurationsService extends RestResource {
  constructor() {
    super('configurations');
  }
}
